import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { ImageLazy } from 'shared/ui/image-lazy'
import { Paper } from 'shared/ui/paper'

import s from './guide-header.module.scss'

type Props = {
  excursionDetails: IExcursionDetails
}

export const GuideHeader = ({ excursionDetails }: Props) => {
  return (
    <Paper>
      <div className={s.carrier}>
        <div className={s.carrierTop}>
          <ImageLazy
            src={excursionDetails?.company_guide.logo_url}
            alt="logo"
            className={s.carrierImage}
          />
          <p className={s.carrierName}>
            {excursionDetails?.company_guide.name}
          </p>
        </div>

        <h4 className={s.excursionName}>{excursionDetails?.name}</h4>
      </div>
    </Paper>
  )
}
